import { css, ElementStyles } from '@microsoft/fast-element';
import { zeroComboboxStyles as styles } from '@genesislcap/foundation-zero';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';

export const customZeroComboboxStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition
): ElementStyles => css`
  ${styles(context, definition)}
  :host(:focus-within:not([disabled])) {
    border-color: var(--primary-color);
  }
`;
